import { Plus, X } from "lucide-react";
import { img } from "../../lib/api";
import { Btn, Card, F, PageHeader, Uploader } from "../../components/admin/ui";
import { useSettingsDoc } from "../../components/admin/useSettingsDoc";

const ListEditor = ({ items, onChange, fields, empty, testid }) => (
  <div className="space-y-3">
    {items.map((it, i) => (
      <div key={i} className="relative grid gap-3 rounded border border-gray-200 p-3 sm:grid-cols-2">
        {fields.map(([k, l, ltr, ta]) => (
          <F key={k} label={l} dir={ltr ? "ltr" : undefined} textarea={ta} testid={`${testid}-${k}-${i}`} value={it[k]} onChange={(v) => onChange(items.map((x, j) => (j === i ? { ...x, [k]: v } : x)))} />
        ))}
        {it.image !== undefined && (
          <div className="flex items-center gap-3 sm:col-span-2">
            {it.image && <img src={img(it.image)} alt="" className="h-16 w-24 rounded object-cover" />}
            <Uploader multiple={false} label="تغيير الصورة" onUploaded={(u) => onChange(items.map((x, j) => (j === i ? { ...x, image: u[0] } : x)))} />
          </div>
        )}
        <button onClick={() => onChange(items.filter((_, j) => j !== i))} className="absolute left-2 top-2 text-red-600"><X size={15} /></button>
      </div>
    ))}
    <Btn variant="light" data-testid={`${testid}-add`} onClick={() => onChange([...items, { ...empty }])}><Plus size={14} />إضافة</Btn>
  </div>
);

export { ListEditor };

export default function Content() {
  const { s, patch, save, busy } = useSettingsDoc();
  if (!s) return null;
  const hero = s.hero || {};
  const h = (k) => ({ value: hero[k], onChange: (v) => patch(`hero.${k}`, v) });
  return (
    <div data-testid="admin-content">
      <PageHeader title="محتوى الصفحة الرئيسية" desc="شريط الإعلانات، الواجهة الرئيسية والبنرات">
        <Btn data-testid="save-content-button" onClick={save} disabled={busy}>حفظ التغييرات</Btn>
      </PageHeader>
      <div className="space-y-4">
        <Card title="شريط الإعلانات العلوي">
          <ListEditor testid="announcement" items={s.announcements || []} onChange={(v) => patch("announcements", v)} empty={{ text_ar: "", text_en: "" }}
            fields={[["text_ar", "النص بالعربية"], ["text_en", "English", true]]} />
        </Card>
        <Card title="الواجهة الرئيسية (Hero)">
          <div className="grid gap-3 sm:grid-cols-2">
            <F label="العنوان (استخدمي | للفصل)" testid="hero-title-ar-input" {...h("title_ar")} />
            <F label="Title (EN)" dir="ltr" {...h("title_en")} />
            <F label="الوصف المختصر" testid="hero-subtitle-ar-input" {...h("subtitle_ar")} />
            <F label="Subtitle (EN)" dir="ltr" {...h("subtitle_en")} />
            <F label="نص الزر" {...h("cta_ar")} />
            <F label="Button (EN)" dir="ltr" {...h("cta_en")} />
            <F label="رابط الزر" dir="ltr" {...h("link")} />
            <div className="flex items-end gap-3">
              {hero.image && <img src={img(hero.image)} alt="" className="h-16 w-24 rounded object-cover" />}
              <Uploader multiple={false} label="صورة الواجهة" testid="hero-image-upload" onUploaded={(u) => patch("hero.image", u[0])} />
            </div>
          </div>
        </Card>
        <Card title="بنرات العروض">
          <ListEditor testid="banner" items={s.banners || []} onChange={(v) => patch("banners", v)} empty={{ title_ar: "", title_en: "", subtitle_ar: "", subtitle_en: "", link: "/shop/offers", image: "" }}
            fields={[["title_ar", "العنوان"], ["title_en", "Title", true], ["subtitle_ar", "الوصف"], ["subtitle_en", "Subtitle", true], ["link", "الرابط", true]]} />
        </Card>
      </div>
    </div>
  );
}
